/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Menu } from '@headlessui/react'
import clsx from 'clsx'
import { UiDropdownItem } from '../UiDropdown'

interface UiDropdownItemComponentProps {
    item: UiDropdownItem
}

const UiDropdownItemComponent: React.FC<UiDropdownItemComponentProps> = ({
    item,
}) => {
    return (
        <Menu.Item disabled={item.disabled}>
            {({ active }) => (
                <button
                    onClick={item.onClick}
                    className={clsx(
                        'UiDropdownItemComponent group flex w-full items-center rounded-lg px-3 py-2 text-sm transition-colors text-left',
                        active
                            ? item.variant === 'danger'
                                ? 'bg-red-50 text-red-600 dark:bg-red-900/20 dark:text-red-400'
                                : 'bg-gray-100 text-gray-900 dark:bg-gray-800 dark:text-gray-100'
                            : item.variant === 'danger'
                              ? 'text-red-600 dark:text-red-400'
                              : 'text-gray-700 dark:text-gray-300',
                        item.disabled && 'pointer-events-none opacity-50'
                    )}
                >
                    {item.icon && (
                        /* @ts-ignore */
                        <item.icon
                            className={clsx(
                                'mr-2 size-4',
                                active ? '' : 'text-gray-400'
                            )}
                            aria-hidden="true"
                        />
                    )}
                    {item.label}
                </button>
            )}
        </Menu.Item>
    )
}

export default UiDropdownItemComponent
